import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Escalation from "./Escalation";
import SalesDashboard from "./SalesDashboard";
import PostSalesDashboard from "./PostSalesDashboard";
import secureLocalStorage from "react-secure-storage";

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("salesDashboard");
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const tab = searchParams.get("tab");
    setActiveTab(tab);
    secureLocalStorage.setItem("agentId", null);
  }, []);

  // const handleTabChange = (tabKey) => {
  //   setActiveTab(tabKey);
  //   navigate(`/admin-dashboard?tab=${tabKey}`);
  // };

  return (
    <div className="">
      {/* <Tabs
        variant="pills"
        defaultActiveKey="assigned"
        id="uncontrolled-tab-example"
        activeKey={activeTab}
        onSelect={handleTabChange}
        className="pb-2 border-bottom border-2 position-sticky top-0"
      >
        <Tab eventKey="salesDashboard" title="Sales Dashboard" className="mt-2">
          {activeTab === "salesDashboard" && <SalesDashboard />}
        </Tab>
        <Tab eventKey="escalations" title="Escalations" className="mb-3">
          {activeTab === "escalations" && <Escalation />}
        </Tab>

        <Tab
          eventKey="postSalesDashboard"
          title="Post Sales Dashboard"
          className="mt-2"
        >
          {activeTab === "postSalesDashboard" && <PostSalesDashboard />}
        </Tab>
      </Tabs> */}
      <SalesDashboard />
    </div>
  );
}

export default AdminDashboard;
